import React from 'react'

import { formatProtectionCountdown } from './stakingLimits'

const formatAvailableTime = (poolEndTime, availableAtUnix) => {
    if (poolEndTime?.clone) return poolEndTime.clone().add(24, 'hours').format('YYYY-MM-DD HH:mm')
    if (!availableAtUnix) return '-'
    return new Date(availableAtUnix * 1000).toLocaleString()
}

export default function RewardWithdrawalPanel({
    isEnded,
    loading,
    poolInfo,
    protection,
    rewardClaimAudit,
    rewardSymbol,
    t,
    onWithdraw,
}) {
    const availableTime = formatAvailableTime(poolInfo.endTime, protection.availableAtUnix)
    const countdown = formatProtectionCountdown(protection.remainingSeconds)
    const isLocked = !isEnded || !protection.isAvailable
    const auditStatus = rewardClaimAudit?.status || 'idle'
    const auditMessage = auditStatus === 'checking'
        ? t('正在检查质押用户是否仍有未领取奖励...')
        : auditStatus === 'all-claimed'
            ? t('全部质押用户均已领取奖励，可提前提取剩余奖励资产。')
            : auditStatus === 'unclaimed-rewards'
                ? `${t('仍有未领取奖励的质押用户')}：${rewardClaimAudit.unclaimedUserCount}`
                : auditStatus === 'too-many-users'
                    ? t('质押用户超过 100 个，将继续执行 24 小时安全锁定。')
                    : auditStatus === 'failed'
                        ? t('用户奖励检查失败，将继续执行 24 小时安全锁定。')
                        : ''

    return <section className={`console-owner-funds ${isLocked ? 'is-locked' : 'is-available'}`}>
        <div className="console-owner-funds__heading">
            <span className="console-eyebrow">{t('资金管理（所有者）')}</span>
            <h3>{t('奖励提取保护')}</h3>
            <p>{t('矿池终止后将检查最多 100 个质押用户；若所有奖励均已领取，可立即提取，否则需等待 24 小时。')}</p>
            {isEnded && auditMessage && <p className={`console-owner-funds__audit is-${auditStatus}`}>{auditMessage}</p>}
        </div>
        <div className="console-owner-funds__lock" aria-hidden="true">
            <i className={`fa ${isLocked ? 'fa-lock' : 'fa-unlock-alt'}`} />
        </div>
        <div className="console-owner-funds__countdown">
            <span>{isEnded ? t('距离可提取') : t('矿池尚未结束')}</span>
            <strong>{isEnded ? countdown : '--:--:--'}</strong>
            <small>{t('时 : 分 : 秒')}</small>
        </div>
        <dl className="console-owner-funds__times">
            <div><dt>{t('安全锁定期开始时间')}</dt><dd>{poolInfo.endTime?.format?.('YYYY-MM-DD HH:mm') || '-'}</dd></div>
            <div><dt>{t('可提取时间（预计）')}</dt><dd>{isEnded ? availableTime : '-'}</dd></div>
        </dl>
        <div className="console-owner-funds__action">
            <span>{t('剩余奖励资产')}</span>
            <strong>{rewardSymbol || '-'}</strong>
            <p>{isLocked ? t('仍有用户未领取奖励或尚未完成检查，安全锁定期结束后才可提取。') : protection.remainingSeconds > 0 ? t('所有用户均已领取奖励，可以提前提取剩余奖励资产。') : t('安全锁定期已结束，可以提取矿池中的剩余奖励资产。')}</p>
            <button type="button" className="console-button" onClick={onWithdraw} disabled={isLocked || loading} aria-label={t('提取剩余奖励代币')}>
                <i className={`fa ${isLocked ? 'fa-lock' : 'fa-unlock-alt'}`} />
                {loading ? t('处理中...') : isLocked ? t('安全锁定期未结束') : t('提取剩余奖励代币')}
            </button>
        </div>
    </section>
}
